export default __webpack_public_path__ + "static/1-1b1acc6dc3267674cd3b207aee1fa9b8.jpeg";